import React from 'react'

const AlertIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zm0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-.75-14.25a.75.75 0 1 1 1.5 0v6a.75.75 0 1 1-1.5 0v-6zM12 16.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z' />
  </svg>
)

export default AlertIcon
